import { FaPaperclip, FaTrash } from "react-icons/fa";
import { designTokens } from "utils/designSystem";
import { disabledStyle, pdStyles } from "Components/PatentDesign/styles";
import { formatDate, formatFileSize } from "utils/patentDesign";

const FileList = ({ files, onDownload, onDelete, disabled = false, emptyText = "첨부 파일 없음" }) => {
  if (!files.length) return <p style={pdStyles.muted}>{emptyText}</p>;

  return (
    <ul style={pdStyles.fileList}>
      {files.map((file) => (
        <li key={file.id} style={pdStyles.fileItem}>
          <FaPaperclip size={12} color={designTokens.colors.text.muted} />
          <span style={pdStyles.fileName}>
            {file.title && <strong style={pdStyles.fileTitle}>{file.title}</strong>}
            {file.name}
          </span>
          {file.createdAt && <span style={pdStyles.fileMeta}>{formatDate(file.createdAt)}</span>}
          <span style={pdStyles.fileMeta}>{formatFileSize(file.size)}</span>
          <button
            type="button"
            aria-label={`${file.name} 다운로드`}
            style={{ ...pdStyles.linkButton, ...disabledStyle(disabled) }}
            disabled={disabled}
            onClick={() => onDownload(file)}
          >
            다운로드
          </button>
          {onDelete && (
            <button
              type="button"
              aria-label={`${file.title || file.name} 삭제`}
              style={{ ...pdStyles.dangerLink, ...disabledStyle(disabled) }}
              disabled={disabled}
              onClick={() => onDelete(file)}
            >
              <FaTrash size={11} />
              삭제
            </button>
          )}
        </li>
      ))}
    </ul>
  );
};

export default FileList;
